<template lang="pug">
  div.container-fluid.animated.fadeIn
    nav(aria-label="breadcrumb")
      b-breadcrumb
        b-breadcrumb-item
          router-link(to="/monitor")
            i.fa.fa-eye
            span.ml-1 {{ $t("ui.monitor") }}
        b-breadcrumb-item
          router-link(to="/monitor/asidebar")
            i.fa.fa-signal
            span.ml-1 {{ $t("ui.account") }}
    b-card(body-class="p-1").p-0
      b-tabs(small card)
        b-tab(title-link-class="small-link" title-item-class="small-item")
          template(slot="title")
            span(style="padding: 1px; line-height: 16px;") {{ $t("ui.account") }}
          div.row(v-if="userList")
            div.col-6
              .clusterize-scroll(style="max-height: 550px;")
                table.tablex(style="width: 100%;")
                  thead
                    tr
                      th.sticky-position(style="width: 100px;")
                        span {{ $t("ui.providerid") }}
                      th.sticky-position(style="width: 160px;" @click="sortOrder('account_id', 'account')")
                        span {{ $t("ui.username") }}
                        i(:class="changeSortKey('account_id', 'account')")
                      th.sticky-position(style="width: 160px;" @click="sortOrder('bot_id', 'account')")
                        span {{ $tc("ui.bots", 1) }}
                        i(:class="changeSortKey('bot_id', 'account')")
                      th.sticky-position(@click="sortOrder('state', 'account')")
                        span {{ $t("ui.status") }}
                        i(:class="changeSortKey('state', 'account')")
                  tbody.clusterize-content
                    tr(v-if="filteredIBCUserList.length == 0")
                      td(colspan="4").text-center
                        span {{ $t('message.no_data_available') }}
                    tr(v-for="(item, index) in filteredIBCUserList" v-if="item")
                      td
                        span {{ item.provider_id }}
                      td
                        span {{ item.account_id }}
                      td
                        span {{ getBotId(item.account_id)}}
                      td(:class="classObject(item, 'account')")
                        span.font-weight-bold.text-uppercase {{ item.state }}
            div.col-6
              .clusterize-scroll(style="max-height: 550px;")
                table.tablex(style="width: 100%;")
                  thead
                    tr
                      th.sticky-position(style="width: 100px;")
                        span {{ $t("ui.providerid") }}
                      th.sticky-position(style="width: 160px;" @click="sortOrder('account_id', 'account')")
                        span {{ $t("ui.username") }}
                        i(:class="changeSortKey('account_id', 'account')")
                      th.sticky-position(style="width: 160px;" @click="sortOrder('bot_id', 'account')")
                        span {{ $tc("ui.bots", 1) }}
                        i(:class="changeSortKey('bot_id', 'account')")
                      th.sticky-position(@click="sortOrder('state', 'account')")
                        span {{ $t("ui.status") }}
                        i(:class="changeSortKey('state', 'account')")
                  tbody.clusterize-content
                    tr(v-if="filteredSBOUserList.length == 0")
                      td(colspan="4").text-center
                        span {{ $t('message.no_data_available') }}
                    tr(v-for="(item, index) in filteredSBOUserList" v-if="item")
                      td
                        span {{ item.provider_id }}
                      td
                        span {{ item.account_id }}
                      td
                        span {{ getBotId(item.account_id) }}
                      td(:class="classObject(item, 'account')")
                        span.font-weight-bold.text-uppercase {{ item.state }}

      bot(ref="bot" :selectedBot="selectedBot")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import _ from "lodash";
import bot from "@/components/status/bot.vue";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    bot,
    DebounceInput
  },
  data() {
    return {
      loading: false,
      loginSearch: "",
      hostList: [],
      userList: [],
      reportList: null,
      sboBotList: [],
      ibcBotList: [],
      loginIdStr: "'",
      loginBotList: [],
      feedback: {
        success: false,
        status: errorTags.request.failed
      },
      selectedBot: null,
      filterBy: "id",
      reportSearch: "",
      currTab: "account",
      providerSortKey: "result",
      providerSortType: "asc",
      accountSortKey: "state",
      accountSortType: "asc",
      statusSortKey: "bot_status",
      statusSortType: "asc"
    };
  },
  computed: {
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    },
    alert:
    {
      get() {
        return this.$store.getters.alertOn;
      },
      set(value) {
        this.changedAlertOn(value);
      }
    },
    filteredSBOUserList() {
      return this.userList.filter((item) => {
        return item.provider_id == 'SBO';
      })
      .sort((a, b) => {
        if (this.accountSortType == 'asc') {
          if (this.accountSortKey == 'account_id') return a.account_id > b.account_id ? 1 : -1;
          // else if (this.accountSortKey == 'state') return a.state > b.state ? 1 : -1;
          else if (this.accountSortKey == 'state') return (a.state === b.state) ? 0 : a.state == 'ok' ? 1 : -1;
          else if (this.accountSortKey == 'bot_id') return a.bot_id > b.bot_id ? 1 : -1;
        } else if (this.accountSortType == 'desc') {
          if (this.accountSortKey == 'account_id') return a.account_id < b.account_id ? 1 : -1;
          // else if (this.accountSortKey == 'state') return a.state < b.state ? 1 : -1;
          else if (this.accountSortKey == 'state') return (a.state === b.state) ? 0 : a.state != 'ok' ? 1 : -1;
          else if (this.accountSortKey == 'bot_id') return a.bot_id < b.bot_id ? 1 : -1;
        }
      });
    },
    filteredIBCUserList() {
      return this.userList.filter((item) => {
        return item.provider_id == 'IBC';
      })
      .sort((a, b) => {
        if (this.accountSortType == 'asc') {
          if (this.accountSortKey == 'account_id') return a.account_id > b.account_id ? 1 : -1;
          // else if (this.accountSortKey == 'state') return a.state > b.state ? 1 : -1;
          else if (this.accountSortKey == 'state') return (a.state === b.state) ? 0 : a.state == 'ok' ? 1 : -1;
          else if (this.accountSortKey == 'bot_id') return a.bot_id > b.bot_id ? 1 : -1;
        } else if (this.accountSortType == 'desc') {
          if (this.accountSortKey == 'account_id') return a.account_id < b.account_id ? 1 : -1;
          // else if (this.accountSortKey == 'state') return a.state < b.state ? 1 : -1;
          else if (this.accountSortKey == 'state') return (a.state === b.state) ? 0 : a.state != 'ok' ? 1 : -1;
          else if (this.accountSortKey == 'bot_id') return a.bot_id < b.bot_id ? 1 : -1;
        }
      });
    },
  },
  mounted: function() {
    this.getReportList();
  },
  methods: {
    classObject(item, type) {
      if (type == 'provider') {
        if (!item.payload.success)
          return 'blink';
        else if (item.payload.result.toLowerCase() == 'ok' || item.payload.result.toLowerCase() == 'success')
          return 'green-bg';
        else
          return 'blue-bg';
      } else if (type == 'account') {
        if (item.state != 'ok')
          return 'blink';
        else
          return 'green-bg';
      } else if (type == 'status') {
        if (!item.success)
          return 'red-bg';
        else if (item.result.toLowerCase() == 'not_open')
          return 'yellow-bg';
        else if (item.result.toLowerCase() == 'ok' || item.result.toLowerCase() == 'success')
          return 'green-bg';
        else
          return 'blue-bg';
        // if (item.toLowerCase() == 'ok' || item.toLowerCase() == 'success')
        //   return 'green-bg';
        // else if (item.toLowerCase() == 'not open')
        //   return 'red-bg';
        // else
        //   return 'blue-bg';
      }

    },
    sortOrder(key, type) {
      if (type == 'provider') {
        if (this.providerSortKey == key)
          this.providerSortType = this.providerSortType == 'asc' ? 'desc' : 'asc';
        else {
          this.providerSortKey = key;
          this.providerSortType = 'asc';
        }
      } else if (type == 'account') {
        if (this.accountSortKey == key)
          this.accountSortType = this.accountSortType == 'asc' ? 'desc' : 'asc';
        else {
          this.accountSortKey = key;
          this.accountSortType = 'asc';
        }
      } else if (type == 'status') {
        if (this.statusSortKey == key)
          this.statusSortType = this.statusSortType == 'asc' ? 'desc' : 'asc';
        else {
          this.statusSortKey = key;
          this.statusSortType = 'asc';
        }
      }
    },
    changeSortKey(key, type) {
      if (type == 'provider') {
        if (this.providerSortKey != key)
          return 'fas fa-sort';
        else if (this.providerSortKey == key && this.providerSortType == 'asc')
          return 'fa fa-sort-up';
        else if (this.providerSortKey == key && this.providerSortType == 'desc')
          return 'fa fa-sort-down';
      } else if (type == 'account') {
        if (this.accountSortKey != key)
          return 'fas fa-sort';
        else if (this.accountSortKey == key && this.accountSortType == 'asc')
          return 'fa fa-sort-up';
        else if (this.accountSortKey == key && this.accountSortType == 'desc')
          return 'fa fa-sort-down';
      } else if (type == 'status') {
        if (this.statusSortKey != key)
          return 'fas fa-sort';
        else if (this.statusSortKey == key && this.statusSortType == 'asc')
          return 'fa fa-sort-up';
        else if (this.statusSortKey == key && this.statusSortType == 'desc')
          return 'fa fa-sort-down';
      }
    },
    setTab: function(index) {
      this.currTab = index;
    },
    getBotId(account_id) {
      if (this.loginBotList.filter(item => { return item.login_id == account_id; }).length > 0)
        return this.loginBotList.filter(item => { return item.login_id == account_id; })[0].bot_id;
      else
        return '';
    },
    getBotList: function(provider) {
      let url = config.botListUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.status,
        bot_id: "",
        bot_name: "",
        provider_id: provider
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                if (provider == 'SBO') {
                  //this.sboBotList = response.data.tbl_bot_list;
                  this.sboBotList = response.data.ds.bot;
                  // this.sboBotList.sort((a, b) => {  });
                }
                else if (provider == 'IBC')
                  this.ibcBotList = response.data.ds.bot;
                  // this.ibcBotList = response.data.tbl_bot_list;
              } else {
                this.$helpers.handleFeedback(this.feedback.status);
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          // Error
          this.loading = false;
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getReportList: function() {
      let url = config.statusListUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.status
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.hostList = response.data.hosts;
                this.userList = response.data.users;
                //testing
                // console.log(this.userList);
                // for(var i = 0; i < this.userList.length; i++) {
                //   if(i % 2 == 0)
                //     this.userList[i].state = "unknown";
                // }
                this.reportList = response.data.reports;
                this.reportList = _.orderBy(this.reportList, ["payload.success", "bot.id"], ["asc"]);
                this.reportList = _.groupBy(this.reportList, "target.provider_id");
                //this.getBotList('SBO');
                //this.getBotList('IBC');
                this.getBotByLoginId();
                // console.log(this.reportList);
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            if (!this.feedback.status.includes('No connection is available to service this operation'))
              this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          if (!this.feedback.status.includes('No connection is available to service this operation'))
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getBotByLoginId: function() {
      let url = config.getBotByLoginIdUrl();

      this.loginIdStr = "'";

      this.loginIdStr = this.loginIdStr + this.userList.map(e => e.account_id).join("', '") + "'";

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.status,
        login_id_str: this.loginIdStr
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.loginBotList = response.data.tbl_login_bot_list;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            if (!this.feedback.status.includes('No connection is available to service this operation'))
              this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          if (!this.feedback.status.includes('No connection is available to service this operation'))
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
  }
};
</script>

<style lang="scss">
.small-item {
  margin-top: 8px !important;
}

.small-link {
  border-top: 1px solid rgba(0, 0, 0, 0) !important;
  padding-top: 4px !important;
  padding-bottom: 4px !important;
}

.active.small-link {
  border-top: 1px solid rgb(216, 210, 222) !important;
  padding-top: 4px !important;
  padding-bottom: 4px !important;
}

.blink {
  -webkit-animation: blinking 1.5s ease infinite; /* Safari 4+ */
  -moz-animation: blinking 1.5s ease infinite; /* Fx 5+ */
  -o-animation: blinking 1.5s ease infinite; /* Opera 12+ */
  animation: blinking 1.5s ease infinite; /* IE 10+, Fx 29+ */
}

.blue-bg {
  background-color: rgb(207, 231, 238) !important;
  color: #456f8b;
}

.green-bg {
  background-color: #B0E3D1 !important;
  color: #486C76;
}

.red-bg {
  background-color: lightcoral !important;
}

.yellow-bg {
  background-color: #EEF9BF !important;
  color: #6A8CAF;
}

tr, td {
  cursor: pointer;
}

@keyframes blinking {
  0% {
    background-color: rgba(255, 255, 255, 0);
    color: rgb(211, 98, 143);
  }
  50% {
    background-color: rgb(211, 98, 143);
    color: #ffffff;
  }
  100% {
    background-color: rgba(255, 255, 255, 0);
    color: rgb(211, 98, 143);
  }
}
</style>